import React from 'react';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import GoogleMap from '@/components/GoogleMap';
import useDestination from '@/hooks/useDestination';
import { useDestination as v2UseDestination } from '@/v2/contexts/destination';
import useViewItemListEvent from '@/v2/hooks/useViewItemListEvent';
import usePropertiesContent from '../../../../hooks/usePropertiesContent';
import Marker from './components/Marker';

const Map = React.memo(() => {
  const propertiesContent = usePropertiesContent();
  const d = useDestination();
  const dV2 = v2UseDestination();
  const destination = d || dV2;
  const { searchQuery } = useSearchQuery();
  const {
    searchConfig: { origins },
  } = destination;

  const originCode = searchQuery?.originCode;

  const title = destination.theme
    ? destination.title
    : `${destination.title} holidays`;

  useViewItemListEvent({
    origins,
    originCode,
    properties: propertiesContent.map((p) => ({
      propertyContent: p,
    })),
    title,
    destinationTitle: destination.title,
    searchType: 'map',
    shouldAutoInvokeOnce: true,
  });

  return (
    <GoogleMap
      zoom={0}
      center={{ lat: 0, lng: 0 }}
      onGoogleApiLoaded={(googleMap) => {
        const { map, maps } = googleMap;

        const { LatLngBounds } = maps;
        const bounds = new LatLngBounds();
        propertiesContent.forEach((p) => bounds.extend(p.geolocation));
        map.fitBounds(bounds);
      }}
      options={{
        fullscreenControl: false,
        scaleControl: true,
      }}
    >
      {propertiesContent.map((p) => (
        <Marker
          key={p.id}
          lat={p.geolocation.lat}
          lng={p.geolocation.lng}
          property={p}
        />
      ))}
    </GoogleMap>
  );
});

export default Map;
